// @flow

// Does the input look blank?
// Returns true on nully values, falsy values and strings with only whitespace.
export const isBlank = (s: mixed) => String(s || '').trim() === '';

export const notBlank = (s: mixed) => !isBlank(s);
